import { TournamentFilter } from "./types";

export const defaultTournamentFilters: TournamentFilter = {
  region: "",
  tier: "",
};
